<div class="content">
  <!-- <div class="section-title">Inspector User ID Report</div> -->
  <div class="tab-content" role="tabpanel" aria-hidden="true">

    <div class="report-description" style="margin-bottom: 15px;">
      <b>Assigned to User ID - Run Report:</b>
      <span>
        This report will provide a list of all TLR's that are owned by the User ID that is inserted into textbox.
        The report will provide three lists: if the User ID is the owner of the Operations data; if the User ID is the
        owner (assignee) of Inspection data; and if the User ID is the owner (assignee) of Engineering data.
      </span>
    </div>

    <div class="add-user-form">
      <div class="user-id-verification">
        <div class="form-row">
          <label for="newUserId">User ID:</label>
          <input pInputText id="newUserId" type="text" (keydown.enter)="verifyUser()" [(ngModel)]="newUserId" class="user-id-input" [disabled]="isClear">
          <div class="verification-buttons">
            <button class="verify-btn" (click)="verifyUser()" [disabled]="isClear">Verify User ID</button>
            <button class="clear-btn" (click)="runReport()" *ngIf="userVerified && assignedCaiReportData">Run
              Report</button>
            <button class="clear-btn" (click)="clearUserID()">Clear User ID</button>

          </div>
        </div>

        <!-- Display message when user does not exists -->
        <p *ngIf="userDoesNotExist" class="verification-message">User ID does not Exists</p>

        <!-- Display user information when verified -->
        <div *ngIf="userVerified && assignedCaiReport" class="user-info-display">
          <p class="user-email"><span>Email: </span>{{assignedCaiReport.email}}</p>
          <p class="user-name"><span>Full Name: </span>{{assignedCaiReport.givenName}}</p>
          <p class="user-city"><span>City: </span></p>
          <p class="user-phone"><span>Phone: </span>{{assignedCaiReport.phoneNumber}}</p>
          <p class="user-phone"><span>{{assignedCaiReport.displayName}} CAI: </span>{{assignedCaiReport.cai}}</p>
        </div>
      </div>
    </div>


  </div>
  <!-- Tab Navigation -->
  <div class="mt-10">
    <np-tabbed class="mt-10" *ngIf="showTab">
      <ul class="tabs">
        <li role="tab" [class.active]="selectedTab === 'operations'" (click)="onTabClick('operations')">Operations</li>
        <li role="tab" [class.active]="selectedTab === 'inspection'" (click)="onTabClick('inspection')">Inspection</li>
        <li role="tab" [class.active]="selectedTab === 'engineering'" (click)="onTabClick('engineering')">Engineering</li>
        <li role="tab" [class.active]="selectedTab === 'oa'" (click)="onTabClick('oa')">OA</li>
      </ul>


      <!-- Shared Table -->
      <div class="tab-content" *ngIf="showTable && assignedCaiReportData?.length">


        <div class="exportToExcel excel-btn">
          <button pButton type="button" label="Export To Excel" icon="pi pi-file-excel" class="p-button-outlined"
            (click)="exportToExcel()">Export To Excel</button>
        </div>

        <p-table [value]="assignedCaiReportData" [rows]="10" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th>Tag Number</th>
              <th>Entry Date</th>
              <th>TLR Status</th>
              <th>Oper User ID</th>
              <th>Division</th>
              <th>Section</th>
              <th>Plant</th>
              <th>LDAR</th>
              <th>Op. PSI</th>
              <th>Op. Temp</th>
              <th>ShutdownDescription</th>
              <th>Service</th>
              <th>Insp User ID</th>
              <th>Service Class</th>
              <th>OA User ID</th>
              <th>Permanent Repair Date</th>
              <th>Eng User ID</th>
              <th>TLR Type</th>
              <th>Maximo WO Number</th>
              <th>Maximo Outage- T/A</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-detail>
            <tr>
              <td><a routerLink="/details-section/{{detail.Tag_Number}}">{{ detail.Tag_Number }}</a></td>
              <td>{{detail.Data_Entry_Date | date:'MM/dd/YYYY'}}</td>
              <td>{{detail.TLR_Status}}</td>
              <td>{{detail.Operator_CAI}}</td>
              <td class="left-align">{{detail.Division}}</td>
              <td class="left-align">{{detail.Section}}</td>
              <td class="left-align">{{detail.Plant}}</td>
              <td class="left-align">{{detail.LDAR}}</td>
              <td>{{detail.Oper_PSI}}</td>
              <td>{{detail.Oper_Temp}}</td>
              <td class="left-align">{{detail.ShutdownDescription}}</td>
              <td>{{detail.Service}}</td>
              <td>{{detail.InspectionCAI}}</td>
              <td>{{detail.ServiceClass}}</td>
              <td>{{detail.OACAI}}</td>
              <td [ngClass]="commonService.getDateColorClass(detail.Permanent_Repair_Date)">{{detail.Permanent_Repair_Date | date:'MM/dd/yyyy'}}</td>
              <td>{{detail.EngineeringCAI}}</td>
              <td>{{detail.TLRType}}</td>
              <td>{{detail.Maximo_WO_Number}}</td>
              <td>{{detail.Maximo_Outage_TA}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </np-tabbed>
  </div>
</div>